const listMenuChildTypes = [
  {
    id: 1,
    name: '通常'
  },
  {
    id: 2,
    name: 'こども食堂用(単独)'
  },
  {
    id: 3,
    name: 'こども食堂用(仮想店舗)グループ'
  },
  {
    id: 4,
    name: 'グループ共通メニュー'
  },
  {
    id: 5,
    name: '地域通貨チケット'
  }
];
export default listMenuChildTypes;
